import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "@/context/ThemeContext";

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation("home");
  const { effectiveTheme } = useTheme();
  const isLight = effectiveTheme === "light";

  return (
    <div
      className={`relative flex flex-col items-center justify-center h-screen text-center px-4 ${
        isLight ? "bg-[#f5f5f7]" : "bg-cosmic-950"
      }`}
    >
      <h1
        className={`absolute bottom-0 text-9xl md:text-[12rem] font-black select-none pointer-events-none z-0 ${
          isLight ? "text-gray-200" : "text-white/[0.04]"
        }`}
      >
        404
      </h1>
      <div className="relative z-10">
        <h1
          className={`text-xl md:text-2xl font-semibold mt-6 ${
            isLight ? "text-[#1c1c1e]" : "text-white"
          }`}
        >
          {t("notFound.title")}
        </h1>
        <p
          className={`mt-2 text-base font-mono ${
            isLight ? "text-[#6e6e73]" : "text-gray-400"
          }`}
        >
          {location.pathname}
        </p>
        <p
          className={`mt-4 text-lg md:text-xl ${
            isLight ? "text-[#6b6b7b]" : "text-gray-500"
          }`}
        >
          {t("notFound.hint")}
        </p>
      </div>
    </div>
  );
}